import { isEditorLive } from 'components/shared/tiptap/editorLiveness'

const STALE_TIPTAP_TRANSACTION_ERROR = 'Applying a mismatched transaction'

export function isStaleTiptapTransactionError(error: unknown): boolean {
    return error instanceof Error && error.message === STALE_TIPTAP_TRANSACTION_ERROR
}

type EditorLike = {
    isDestroyed?: boolean
    focus?: () => void
    getEditor?: () => {
        isDestroyed?: boolean
        focus?: () => void
        setSelection?: (index: number, length: number) => void
        getLength?: () => number
    } | null
    commands?: {
        focus?: (position?: string, options?: { scrollIntoView?: boolean }) => void
    }
}

export function focusEditorAtEndSafely(
    editor: EditorLike | null | undefined,
    isCurrentEditor: () => boolean = () => true,
): boolean {
    if (!editor || !isCurrentEditor()) return false
    // A handle whose underlying editor was destroyed still answers every
    // call — and throws inside TipTap when it does.
    if (!isEditorLive(editor)) return false
    const inner = editor.getEditor?.()
    if (inner !== undefined && !isEditorLive(inner)) return false

    if (typeof editor.focus === 'function') {
        editor.focus()
    } else if (inner) {
        inner.focus?.()
    }

    if (!isCurrentEditor()) return false

    if (editor.commands?.focus) {
        try {
            editor.commands.focus('end', { scrollIntoView: false })
            return true
        } catch (e) {
            if (isStaleTiptapTransactionError(e)) return false
            throw e
        }
    }

    if (inner) {
        const quill = inner
        if (quill?.setSelection && quill?.getLength) {
            const length = quill.getLength()
            quill.setSelection(length, 0)
            return true
        }
    }

    return true
}
